import { createApp } from 'vue';
import App from './App.vue';
import './style.css';
import { useTheme } from './composables/useTheme';

const app = createApp(App);
useTheme().initTheme();
app.mount('#app');

if (typeof window !== 'undefined' && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/geobu/sw.js').catch(() => undefined);
  });
}
